
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShiftAvailableEmploymentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShiftAvailableEmployment"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"availabilityInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endsAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startsAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"unavailable"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endsAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startsAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"partialAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partialUnavailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"complete"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullUnavailable"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"conflicts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShiftConflictsFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"contractMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"employmentWorkHour"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isMonthly"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"monthlyMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weeklyMinutes"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hourEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maximumMoney"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maximumMoneyEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pictureData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pictureSmall"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"staffNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"employmentsShiftRotationGroups"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shiftRotationGroupId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startsAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endsAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"qualificationIds"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"hasConflicts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hourAccountHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"joinRequest"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"maximumMoney"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scheduledMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scheduledMoney"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shiftId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workedMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bringShiftHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bringShiftHoursUsed"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":1003}};
    doc.loc.source = {"body":"#import \"store/shifts/queries/ShiftConflictsFragment.gql\"\n\nfragment ShiftAvailableEmploymentFragment on ShiftAvailableEmployment {\n  id\n  availabilityInfo {\n    available {\n      endsAt\n      startsAt\n    }\n    unavailable {\n      endsAt\n      startsAt\n    }\n    partialAvailable\n    partialUnavailable\n    complete\n    fullAvailable\n    fullUnavailable\n  }\n  conflicts {\n    ...ShiftConflictsFragment\n  }\n  contractMinutes\n  employment {\n    id\n    employmentWorkHour {\n      isMonthly\n      monthlyMinutes\n      weeklyMinutes\n    }\n    firstName\n    hourEnabled\n    lastName\n    maximumMoney\n    maximumMoneyEnabled\n    pictureData {\n      pictureSmall\n    }\n    staffNumber\n    employmentsShiftRotationGroups {\n      id\n      shiftRotationGroupId\n      startsAt\n      endsAt\n    }\n    qualificationIds\n  }\n  hasConflicts\n  hourAccountHours\n  joinRequest {\n    id\n    createdAt\n  }\n  maximumMoney\n  scheduledMinutes\n  scheduledMoney\n  shiftId\n  workedMinutes\n  bringShiftHours\n  bringShiftHoursUsed\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("store/shifts/queries/ShiftConflictsFragment.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ShiftAvailableEmploymentFragment"] = oneQuery(doc, "ShiftAvailableEmploymentFragment");
        
